import { BASE_URL } from '../configs/config';

export const getUserInfo = async (userId: string) => {
  try {
    const res = await fetch(`${BASE_URL}checkRestInfo?user_id=${userId}`, {
      method: 'GET',
      cache: 'no-cache',
    });
    const data = await res.json();
    return data;
  } catch (error) {}
};
